<template>
  <Drawer :value="true" :width="width" @close="$emit('exit')">
    <v-container class="py-12 px-5 px-md-7 pa-md-16">
      <v-card-title
        class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
      >
        Project Location
      </v-card-title>

      <v-list-item-group color="primary" class="mb-12">
        <v-list-item :inactive="true" :ripple="false" color="#2f2727">
          <v-list-item-icon>
            <v-icon color="black">$marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ getLocationString(project.location) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="!currentUser.isTourist()"
          :to="{ name: 'edit-project', params: { id: project.id } }"
        >
          <v-list-item-icon>
            <v-icon color="black">$edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold primary--text">
              Edit Site
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>

      <div class="map-container position-relative">
        <div class="map-card rounded-map" style="height:300px">
          <MapBox
            :show-zoom="true"
            :zoom="8"
            :mark-center="true"
            :center="{ ...project.location, name: project.name }"
          />
        </div>
      </div>
    </v-container>
  </Drawer>
</template>

<script>
import Drawer from '@layouts/_partials/Drawer';
import MapBox from '@components/utilities/MapBox';

export default {
  name: 'ProjectLocation',
  components: { MapBox, Drawer },
  props: {
    project: {
      type: Object,
      required: true,
    },
    width: {
      type: [String, Number],
      default: 350,
    },
  },
};
</script>

<style lang="scss" scoped></style>
